<template>
  <router-view />
</template>
  
<script>
export default {
  beforeRouteUpdate(to, from, next) {
    if (to.name == "ven-grupocomissao") {
      next({ name: "ven-grupocomissao-list" });
    } else {
      next();
    }
  },
  created() {
    if (this.$route.name == "ven-grupocomissao") {
      this.$router.push({ name: "ven-grupocomissao-list" });
    }
  },
};
</script>